import React, { Dispatch } from 'react';
import { connect } from 'react-redux';
import { Common } from '../../core/common';
import { Log } from 'ng2-logger';
import Translator from '../../core/i18n';
import { Formik, FormikProps } from 'formik';
// @ts-ignore
import PivotTableUI from 'react-pivottable/PivotTableUI';
// @ts-ignore
import TableRenderers from 'react-pivottable/TableRenderers';
// @ts-ignore
import createPlotlyRenderers from 'react-pivottable/PlotlyRenderers';
import Plot from 'react-plotly.js';
import 'react-pivottable/pivottable.css';
import { ReportService } from '../../api/report-services';
import { BackgroundService } from '../../api/background-service';
import { getValidation } from '../../models/validations/report-enrollments';
import { IAction, IAppState } from '../../models/action/core';
import { ActivityTypeEnums } from '../../models/enums/ActivityType';
import { enrollmentStatus } from '../../models/enums/enrollmentStatus';
import { DatetimeFormik } from '../../components/input/date-time/date-time-formik';
import { IPreference } from '../../models/action/profile';
import { Course } from '../../components/filters/course';
import { Class } from '../../components/filters/class';
import { User } from '../../components/filters/user';
import { ActivityType } from '../../components/filters/activityType';
import { Activity } from '../../components/filters/activity';
import { EnrollmentStatus } from '../../components/filters/enrollmentStatus';
import { Notification } from '../../components/notification/main';
import Moment from 'moment';
import queryString from 'querystring';
import BaseModal from '../../modal/base-modal/main';
import { Table } from 'reactstrap';
import SortedColumn from '../../components/table/sorted-column';
import { Guid } from 'guid-typescript';
import { SelectNoneAsync } from '../../components/input/select/main';
import Paginate from '../../components/table/paginate';
import { IEnrollmentReportsState } from '../../models/components/IEnrollmentReportsState';
import { IEnrollmentReportsFormikProps } from '../../models/components/IEnrollmentReportsFormikProps';
import { ISelectRows } from '../../models/components/ISelectRows';
import { IEnrollmentReportsProps } from '../../models/components/IEnrollmentReportsProps';
import { ReportType } from '../../models/enums/ReportType';
import imgAnn from '../../static/images/announcement.svg';
import Select from 'react-select';
import { UserType } from '../../models/enums/userType';

const T = Translator.create();
const _logger = Log.create('Reports Page');
let _common: Common;

const PlotlyRenderers = createPlotlyRenderers(Plot);
const _reportService = new ReportService();
const _backgroundService = new BackgroundService();

const pivotTableRef = React.createRef<PivotTableUI>();

const options = [
    { value: 10, label: '10' },
    { value: 25, label: '25' },
    { value: 50, label: '50' },
    { value: 100, label: '100' },
];

const customStyles: any = {
    control: (styles: any) => ({
        ...styles,
        background: 'white',
        color: 'white',
        boxShadow: 'none',
        borderColor: '#ccc',
        borderWidth: 0,
        borderBottomWidth: 1,
        borderRadius: 0
    }),
};

class EnrollmentReports extends React.Component<IEnrollmentReportsProps, IEnrollmentReportsState> {
    public state: IEnrollmentReportsState = {
        isExpertMode: false,
        reportData: [],
        selectCourse: '',
        isReportShow: false,
        selectedOption: [{ value: 10, label: '10' }],
        _colOrder: '',
        _rowOrder: '',
        _cols: [],
        _rows: [],
        _tempCols: [],
        _tempRows: [
            T.t('r_gen_excel_username'),
            T.t('r_gen_excel_fullname'),
            T.t('r_gen_excel_coursename'),
            T.t('r_gen_excel_classname'),
            T.t('r_gen_excel_activitytype'),
            T.t('r_gen_excel_activityname'),
            T.t('r_gen_excel_status'),
            T.t('r_gen_excel_completiondate'),
            T.t('r_gen_excel_score'),
            T.t('r_gen_excel_liveduration'),
            T.t('r_gen_excel_virtualclassreplayduration')
        ],
        _nameRows: [
            T.t('r_gen_excel_username'),
            T.t('r_gen_excel_fullname'),
            T.t('r_gen_excel_activityname'),
            T.t('r_gen_excel_coursename'),
            T.t('r_gen_excel_classname'),
            T.t('r_gen_excel_activitytype'),
            T.t('r_gen_excel_status'),
            T.t('r_gen_excel_score'),
            T.t('r_gen_excel_completiondate'),
            T.t('r_gen_excel_virtualclassreplayduration'),
            T.t('r_gen_excel_liveduration')
        ],
        guid: '',
        isSaveModelOpen: false,
        templateName: '',
        isUpdate: false,
        clear: false,
        submitValues: null,
        isSelected: false,
        filters: {
            page: 1,
            take: 10,
            total: 0
        },
    };
    constructor(props: IEnrollmentReportsProps) {
        super(props);
        this.onChangePivot = this.onChangePivot.bind(this);
        this.onDownload = this.onDownload.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        _common = new Common();
    }

    public onChangePivot(s: any) {
        delete s.data;
        this.setState(s);
        this.setState({ _cols: s.cols, _rows: s.rows, _rowOrder: s.rowOrder, _colOrder: s.colOrder });

    }

    componentDidUpdate(prevProps: Readonly<IEnrollmentReportsProps>, prevState: Readonly<IEnrollmentReportsState>, snapshot?: any): void {
        this.handlePivotTableLoad();
    }

    public onChangeTake = (event: any) => {
        this.state.selectedOption = event;
        this.setState({ selectedOption: event });
        this.state.filters.take = event.value;
        this.setState(this.state);
        this.onSubmit(this.state.submitValues);
    };

    onSubmit = async (values: IEnrollmentReportsFormikProps) => {

        this.setState({ isReportShow: true });
        this.setState({ isSelected: true });
        this.setState({ reportData: [] });
        if (values.dateRange) {
            if (!values.dateRange.includes('-')) {
                Notification.setNotification('error', T.t('dateRange_error'), 'topRight');
            } else {
                values.beginDate = values.dateRange
                    ? Moment(values.dateRange.substring(0, 10), _common.findDateFormat(this.props.userPreferences!)).format(
                        window.appSettings.DefaultDateFormatApi
                    )
                    : values.beginDate;

                values.endDate = values.dateRange
                    ? Moment(values.dateRange.substring(13, values.dateRange.length), _common.findDateFormat(this.props.userPreferences!))
                        .endOf('day')
                        .format(window.appSettings.DefaultDateFormatApi)
                    : values.endDate;
            }
        } else {
            values.beginDate = '';
            values.endDate = '';
        }

        try {
            // _logger.data('this.props.culture', this.props.culture);

            if (this.state.guid === ReportType.StandartReport) {
                const tempRowsData = this.state._tempRows.concat(values.rowNameList);
                values.rowNames = tempRowsData;
                this.setState({ submitValues: values });
                values.take = this.state.filters.take;
                values.skip = this.state.filters.skip;
            }

            const reportData = await _reportService.RequestEnrollmentData(values);
            const reportJson = await reportData.json();

            this.setState({ reportData: reportJson, formikValues: values });
        } catch {
            Notification.setNotification('error', T.t('r_report_page_get_error_message'), 'topRight');
        }
    };

    onDownload = async () => {
        try {
            const params = this.state.formikValues;

            if (params) {
                let isError = false;
                let errorList: any;

                params.rows = this.state._rows.length > 0 ? this.state._rows : this.state._tempRows;
                params.cols = this.state._cols.length > 0 ? this.state._cols : this.state._tempCols;
                params.colOrder = this.state._colOrder;
                params.rowOrder = this.state._rowOrder;
                await _backgroundService
                    .RequestDownloadEnrollmentDataAsync(params)
                    .then((responseData: Response) => {
                        return responseData;
                    })
                    .then((responseData: Response) => {
                        if (responseData.status !== 200) {
                            isError = true;
                        }
                        return responseData;
                    })
                    .then(response => {
                        if (isError) {
                            errorList = response;
                        }
                    });

                if (isError) {
                    Object.keys(errorList).forEach((key: any) => {
                        Notification.setNotification('error', T.t(errorList[key]), 'topRight');
                    });
                }

                if (!isError) {
                    Notification.setNotification('success', T.t('r_gen_background_activityReport_pending'), 'topRight');
                }
            }
        } catch {
            Notification.setNotification('error', T.t('r_report_page_get_error_message'), 'topRight');
        }
    };

    validateAndSubmit = async (formik: FormikProps<IEnrollmentReportsFormikProps>) => {
        const validations = await formik.validateForm().then((result: any) => result);
        Object.keys(validations).forEach((validationKey: string) => {
            if (validationKey) {
                Notification.setNotification(
                    'error',
                    T.t('r_validation_report_' + validationKey) + ' - ' + validations[validationKey],
                    'topRight'
                );
            }
        });

        formik.submitForm();
    };

    getReportTemplates = async () => {
        let search = window.location.search;
        search = search.replace('?', '');
        const params = queryString.parse(search);
        this.setState({ guid: params.templateId });
        if (params.templateId !== ReportType.PivotTableReport && params.templateId !== ReportType.StandartReport) {
            const reportData = await _reportService.RequestReportChoises(params.templateId);
            const data = await reportData.json();
            if (data.cols.length > 0 || data.rows.length > 0) {
                this.setState({ _tempCols: data.cols, _tempRows: data.rows, templateName: data.templateName });
            }
        }
    };

    public componentDidMount() {
        this.getReportTemplates();
    }

    triggerSaveModal = () => {
        this.setState({
            isSaveModelOpen: !this.state.isSaveModelOpen
        });
    };

    templateNameOnChange = (e: any) => {
        if (e) {
            this.setState({ templateName: e.target.value });
        }
    };

    saveTemplate = async (isUpdate: boolean) => {
        if (isUpdate) {
            const params = {
                cols: this.state._cols,
                rows: this.state._rows,
                name: this.state.templateName,
                templateGuid: this.state.guid
            };
            await _reportService.RequestUpdateReportTemplate(params);
        } else {
            if (this.state._rows.length > 0 || this.state._cols.length > 0) {
                const params = {
                    cols: this.state._cols,
                    rows: this.state._rows,
                    name: this.state.templateName
                };
                await _reportService.RequestAddReportTemplate(params);
            } else {
                const params = {
                    cols: this.state._tempCols,
                    rows: this.state._tempRows,
                    name: this.state.templateName
                };
                await _reportService.RequestAddReportTemplate(params);
            }
        }
        this.triggerSaveModal();
    };

    preEditTemplate = async () => {
        if (this.state._rows.length > 0 || this.state._cols.length > 0) {
            this.setState({ isUpdate: true });
            this.triggerSaveModal();
        }
    };

    preSaveTemplate = async () => {
        this.setState({ isUpdate: false });
        this.triggerSaveModal();
    };
    changeVisual = async () => {
        if (this.state.isExpertMode) {
            $('.pvtUi > tbody:nth-child(1) > tr:nth-child(1)').hide();
            $('.pvtUi > tbody:nth-child(1) > tr:nth-child(2)').hide();
            $('td.pvtAxisContainer:nth-child(1)').hide();
            this.setState({ isExpertMode: false });
        } else {
            $('.pvtUi > tbody:nth-child(1) > tr:nth-child(1)').attr('style', 'display:inline-block');
            $('.pvtUi > tbody:nth-child(1) > tr:nth-child(2)').show();
            $('td.pvtAxisContainer:nth-child(1)').show();
            this.setState({ isExpertMode: true });
        }
    };


    clearFilters = async (e: FormikProps<IEnrollmentReportsFormikProps>) => {
        e.setFieldValue('selectedCourses', []);
        e.setFieldValue('selectedClasses', []);
        e.setFieldValue('selectedUsers', []);
        e.setFieldValue('selectedActivities', []);
        e.setFieldValue('selectedActivityTypes', []);
        e.setFieldValue('selectedStatuses', []);
        e.setFieldValue('dateRange', '');
    };

    public handleSelectedRows = (e: ISelectRows[]): any[] => {
        const rowList: any[] = [];
        if (e && e.length) {
            e.forEach(row => rowList.push(row.value));
        }
        return rowList;
    };

    public onPageChange = (page: number) => {
        this.state.filters.page = page;
        this.setState(this.state);
        this.onSubmit(this.state.submitValues);
    };

    public onChangeDateFilter(selectValue: any, formik: FormikProps<IEnrollmentReportsFormikProps>) {
        if (selectValue) {
            formik.setFieldValue('dateFilter', selectValue);
        }
    }

    viewTotalRowCount = (totalRowCount: any, dataLength: any) => {
        if (totalRowCount?.length > 0) {
            if (totalRowCount.pop()) {
                return dataLength.reverse()[0];
            }
            else {
                return 0;
            }
        }
        else {
            return 0;
        }

    }

    viewData = (data: any) => {
        if (data) {
            return data;
        }
        else {
            return '-'
        }


    }

    createdDateStatus = (formik: any, stringData: string) => {

        if (formik.values.dateFilter === stringData) {
            return true;
        }
        else {
            return false;
        }

    }

    getDataLength = (totalRowCount: any) => {
        if (totalRowCount && totalRowCount.length > 0) {
            if (totalRowCount.pop()) {
                return totalRowCount.pop();
            }
            else {
                return undefined;
            }

        }
        else {
            return undefined
        }
    }

    modalFooter = () => {
        return (
            <div className="modal-footer">
                <button
                    type="button"
                    // tslint:disable-next-line:jsx-no-lambda
                    onClick={() => this.triggerSaveModal()}
                    className="btn btn-gray"
                >
                    {T.t('r_cancel')}
                </button>
                <button
                    type="button"
                    // tslint:disable-next-line:jsx-no-lambda
                    onClick={() => this.saveTemplate(this.state.isUpdate)}
                    className="btn btn-green"
                >
                    {T.t('r_save_button')}
                </button>
            </div>
        );
    }


    getTemplateDesc = () => {
        if (this.state.isUpdate) {
            return T.t('r_report_template_update_desc');
        }
        else {
            return T.t('r_report_template_desc');
        }
    }

    handlePivotTableLoad = () => {
        if(pivotTableRef.current){
            document.querySelectorAll('.pvtTotalLabel').forEach(col => {
                col.textContent = T.t("r_gen_excel_totals");
            });
        }
        
    }

    viewReportTable = (basicReportRows: any, basicReportData: any, totalRowCount: any, dataLength: any, pivotReportData: any) => {        
        if (this.state.reportData.length <= 0 && this.state.isReportShow) {
            return (<div className="row mt-4 spinner_bg">
                <div className="donut" />
                <span className="report_title">{T.t('r_gen_reports_loading')}</span>
            </div>);
        }
        else if (this.state.reportData.length > 1) {
            return (<div
                className="container slideInUp show animated container-rpt "
                style={this.state.isReportShow ? { display: 'block', maxWidth: 'none', width: '95%' } : { display: 'none' }}
            >
                <div className="row">
                    <div className="col-md-12">
                        <div
                            className="d-flex justify-content-between student-course-header"
                            style={{ paddingBottom: '10px', paddingTop: 20 }}
                        >
                            <h6 className="mb-3 mb-md-0">{T.t('r_menu_report')}</h6>
                            <div className="d-flex">

                                {this.state.guid !== ReportType.StandartReport && (
                                    <>
                                        <button
                                            // tslint:disable-next-line:jsx-no-lambda
                                            onClick={() => this.changeVisual()}
                                            className="ml-2 category-tag-square tag-green"
                                        >
                                            {' '}
                                            {this.state.isExpertMode
                                                ? T.t('r_report_hideReportColumn')
                                                : T.t('r_report_showReportColumn')}{' '}
                                        </button>
                                        <button
                                            // tslint:disable-next-line:jsx-no-lambda
                                            onClick={() => this.preSaveTemplate()}
                                            className="ml-2 category-tag-square tag-green"
                                        >
                                            {' '}
                                            {T.t('r_report_template_saveas')}
                                        </button>
                                        {this.state.guid !== ReportType.PivotTableReport && (
                                            <button
                                                // tslint:disable-next-line:jsx-no-lambda
                                                onClick={() => this.preEditTemplate()}
                                                disabled={!(this.state._rows.length > 0 || this.state._cols.length > 0)}
                                                className="ml-2 category-tag-square tag-green"
                                            >
                                                <i className="material-icons">save</i>
                                            </button>
                                        )}
                                    </>
                                )}
                            </div>
                            <BaseModal
                                minWidth={650}
                                backdrop="static" 
                                modalIsOpen={this.state.isSaveModelOpen}
                                onClose={this.triggerSaveModal}
                                showHeader={true}
                                headerState={T.t('r_report_template_modal_header')}
                                headerIcon={'clock'}
                                modalFooter={() => {
                                    return this.modalFooter();
                                }}
                            >
                                <div className="info-box">
                                    <p>
                                        {this.getTemplateDesc()}
                                    </p>
                                </div>
                                <h5>{T.t('r_report_template_name')}</h5>
                                <div className="form-input form-group note-pad mb-0" style={{ minHeight: '169px' }}>
                                    <input
                                        id="templateNameInput"
                                        value={this.state.isUpdate ? this.state.templateName : undefined}
                                        // tslint:disable-next-line:jsx-no-lambda
                                        onChange={(e: any) => {
                                            this.templateNameOnChange(e);
                                        }}
                                        type="text"
                                        placeholder={T.t('r_report_template_name')}
                                    />
                                </div>
                            </BaseModal>
                        </div>
                        <div>
                            {this.state.guid === ReportType.StandartReport ? (
                                <div id="basicReportTable" style={{ boxShadow: '0 6px 12px 0 rgb(0 0 0 / 12%)' }}>
                                    <Table
                                        className="table-user-list table-ellipsis"
                                        striped={true}
                                        hover={true}
                                        borderless={true}
                                    >
                                        <thead>
                                            <tr style={{ backgroundColor: '#eaeaea' }}>
                                                {this.state.reportData.length > 0
                                                    && basicReportRows.slice(0, -1).map((item: any, index: number) => {
                                                        return (
                                                            <th key={"row_" + item} scope="col" className="text-center">
                                                                {this.state._nameRows[index]}
                                                            </th>
                                                        );
                                                    })
                                                }
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {basicReportData.length > 0
                                                && basicReportData.splice(1).map((item: any) => {
                                                    return (
                                                        <tr
                                                            key={'student-' + Guid.create.toString()}
                                                            data-title={'title'}
                                                            style={{ cursor: 'initial' }}
                                                        >
                                                            {item.slice(0, -1).map((data: any) => {
                                                                return (
                                                                    <td
                                                                        key={Guid.create.toString()}
                                                                        data-label="label"
                                                                        className="text-center"
                                                                        style={{ whiteSpace: 'break-spaces' }}
                                                                    >
                                                                        {this.viewData(data)}
                                                                    </td>
                                                                );
                                                            })}
                                                        </tr>
                                                    );
                                                })
                                            }
                                        </tbody>
                                    </Table>
                                    {this.state.guid === ReportType.StandartReport && this.state.reportData.length > 0 && (
                                        <Paginate
                                            filters={{
                                                skip: this.state.filters.skip,
                                                take: this.state.filters.take,
                                                page: this.state.filters.page,
                                                total: this.viewTotalRowCount(totalRowCount, dataLength)
                                            }}
                                            onPageChange={this.onPageChange}
                                        />
                                    )}
                                </div>
                                ) : (
                                    <div className="shadow">
                                        <PivotTableUI
                                            ref={pivotTableRef}
                                            data={pivotReportData}
                                            rows={this.state._tempRows}
                                            cols={this.state._tempCols}
                                            onChange={this.onChangePivot}
                                            renderers={({ ...TableRenderers, ...PlotlyRenderers})}
                                            unusedOrientationCutoff={Infinity}
                                            {...this.state} 
                                        />
                                    </div>
                                ) 
                            }
                        </div>
                    </div>
                </div>
            </div>);
        }
        else if (this.state.isReportShow) {
            return (<div className="row mx-0 mt-4 report_info_bg">
                <div className="d-flex justify-content-start flex-column align-items-center report_info_text  col-12">
                    <img src={_common.GetDefaultIcons('cloud')} alt="cloud" />
                    <h5>
                        {T.t('r_gen_reports_data_not_found')}
                    </h5>
                    <p>{T.t('r_gen_reports_data_not_found_desc')}</p>

                </div>
            </div>);
        }
        else {
            return (<><img style={{ marginInlineStart: 'calc(50% - 89px)', marginTop: '2em' }} src={imgAnn} />


                <h5 className='d-block' style={{ marginTop: 15, textAlign: 'center', marginBottom: 50 }}>
                    {
                        T.t('r_gen_report_not_searched')
                    }
                </h5></>);
        }

    }

    render() {
        const initialFormValues: IEnrollmentReportsFormikProps = {
            rowNames: [],
            rowNameList: [],
            selectedCourses: [],
            selectedBranches: [],
            selectedClasses: [],
            selectedUsers: [],
            selectedActivities: [],
            selectedActivityTypes: [],
            selectedStatuses: [],
            take: 100,
            dateRange: '',
            dateFilter: 'CreatedDate',
            termIds: []
        };
        const userDateFormat: string = _common.findDateFormat(this.props.userPreferences!);
        const basicReportData: Array<any> | undefined = [...this.state.reportData];
        const pivotReportData: Array<any> | undefined = [...this.state.reportData];
        const basicReportRows: Array<any> | undefined = [...this.state.reportData].shift();
        const totalRowCount: Array<any> | undefined = this.state.reportData.length > 1 ? [...this.state.reportData] : undefined;
        const dataLength: any = this.getDataLength(totalRowCount);

        return (
            <div>
                <div className="student-course" style={{ paddingBottom: '1em' }}>
                    <div className="question-filter">
                        <div
                            className="container"

                        >
                            <div className="row align-items-center">
                                <div className="col-md-4">
                                    <h6 className="mb-3 mb-md-0">{T.t('r_gen_reports_activity_report')}</h6>
                                </div>
                                <div className="col-md-8 text-md-right">
                                    <div className="options d-inline-flex align-items-center">
                                        <button
                                            data-toggle="modal"
                                            data-target="#preview-question"
                                            className="ml-2 category-tag-square tag-green"
                                            onClick={this.onDownload}
                                        >
                                            <i className="material-icons mr-1">arrow_downward</i>
                                            {T.t('r_gen_download_full_data')}
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <Formik initialValues={initialFormValues} validationSchema={getValidation} onSubmit={this.onSubmit}>
                                {formik => {
                                    return (
                                        <form role="form" key={'activity_report'}>
                                            <div className="filter-fields mt-4">
                                                <div className="row">
                                                    <div className="col col-md-4 col-sm-6 col-6 pb-3">
                                                        <div className="form-input form-group date-picker">
                                                            <Course
                                                                formik={formik}
                                                                value={formik.values.selectedCourses}
                                                                errors={formik.errors.selectedCourses}
                                                                touched={formik.touched.selectedCourses}
                                                                name={'selectedCourses'}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col col-md-4 col-sm-6 col-6 pb-3">
                                                        <div className="form-input form-group date-picker">
                                                            <Class
                                                                formik={formik}
                                                                value={formik.values.selectedClasses}
                                                                errors={formik.errors.selectedClasses}
                                                                touched={formik.touched.selectedClasses}
                                                                name={'selectedClasses'}
                                                                courseIds={formik.values.selectedCourses}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col col-md-4 col-sm-6 col-6 pb-3">
                                                        <div className="form-input form-group date-picker">
                                                            <User
                                                                formik={formik}
                                                                value={formik.values.selectedUsers}
                                                                errors={formik.errors.selectedUsers}
                                                                touched={formik.touched.selectedUsers}
                                                                name={'selectedUsers'}
                                                                courseIds={formik.values.selectedCourses}
                                                                classIds={formik.values.selectedClasses}
                                                                userTypes={[UserType.Student]}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col col-md-4 col-sm-6 col-6 pb-3">
                                                        <div className="form-input form-group date-picker">
                                                            <ActivityType
                                                                formik={formik}
                                                                value={formik.values.selectedActivityTypes}
                                                                errors={formik.errors.selectedActivityTypes}
                                                                touched={formik.touched.selectedActivityTypes}
                                                                name={'selectedActivityTypes'}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col col-md-4 col-sm-6 col-6 pb-3">
                                                        <div className="form-input form-group date-picker">
                                                            <Activity
                                                                formik={formik}
                                                                value={formik.values.selectedActivities}
                                                                errors={formik.errors.selectedActivities}
                                                                touched={formik.touched.selectedActivities}
                                                                name={'selectedActivities'}
                                                                courseIds={formik.values.selectedCourses}
                                                                classIds={formik.values.selectedClasses}
                                                                activityTypes={formik.values.selectedActivityTypes}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col col-md-4 col-sm-6 col-6 pb-3">
                                                        <div className="form-input form-group date-picker">
                                                            <EnrollmentStatus
                                                                formik={formik}
                                                                value={formik.values.selectedStatuses}
                                                                errors={formik.errors.selectedStatuses}
                                                                touched={formik.touched.selectedStatuses}
                                                                name={'selectedStatuses'}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col col-md-4 col-sm-6 col-6 pb-3">
                                                        <div className="form-input form-group date-picker">
                                                            <DatetimeFormik
                                                                name={'dateRange'}
                                                                placeHolder={T.t('r_datetime_picker_date')}
                                                                dateFormat={userDateFormat}
                                                                formik={formik}
                                                                datePickerId={'dateRange'}
                                                                mode="range"
                                                                time24Hr={true}
                                                                isClearable={true}
                                                                static={true}
                                                                className='my-custom-react-select-mid'
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col col-md-4 col-sm-6 col-6 pb-3">
                                                        <div className="form-input form-group date-picker">
                                                            <span
                                                                style={{ display: 'block' }}
                                                                className="control control--radio"
                                                                onClick={this.onChangeDateFilter.bind(this, 'CreatedDate', formik)}
                                                            >
                                                                {T.t('r_gen_questionBank_createdDate')}
                                                                <input
                                                                    type="checkbox"
                                                                    name={'questionDifficulty'}
                                                                    value={'CreatedDate'}
                                                                    id={T.t('CreatedDate')}
                                                                    checked={this.createdDateStatus(formik, 'CreatedDate')}
                                                                    style={{ borderRadius: 100 }}
                                                                />
                                                                <div className="control__indicator" />
                                                            </span>
                                                            <span
                                                                style={{ display: 'block' }}
                                                                className="control control--radio"
                                                                onClick={this.onChangeDateFilter.bind(this, 'FirstAttemptDate', formik)}
                                                            >
                                                                {T.t('r_gen_firstAttemptDate')}
                                                                <input
                                                                    type="checkbox"
                                                                    name={'questionDifficulty'}
                                                                    value={'FirstAttemptDate'}
                                                                    id={T.t('FirstAttemptDate')}
                                                                    checked={this.createdDateStatus(formik, 'FirstAttemptDate')}
                                                                    style={{ borderRadius: 100 }}
                                                                />
                                                                <div className="control__indicator" />
                                                            </span>
                                                            <span
                                                                style={{ display: 'block' }}
                                                                className="control control--radio"
                                                                onClick={this.onChangeDateFilter.bind(this, 'LastAtemptDate', formik)}
                                                            >
                                                                {T.t('r_gen_lastAttemptDate')}
                                                                <input
                                                                    type="checkbox"
                                                                    name={'questionDifficulty'}
                                                                    value={'LastAtemptDate'}
                                                                    id={T.t('LastAtemptDate')}
                                                                    checked={this.createdDateStatus(formik, 'LastAtemptDate')}
                                                                    style={{ borderRadius: 100 }}
                                                                />
                                                                <div className="control__indicator" />
                                                            </span>
                                                            <span
                                                                style={{ display: 'block' }}
                                                                className="control control--radio"
                                                                onClick={this.onChangeDateFilter.bind(this, 'CompletionDate', formik)}
                                                            >
                                                                {T.t('r_gen_completionDate')}
                                                                <input
                                                                    type="checkbox"
                                                                    name={'questionDifficulty'}
                                                                    value={'CompletionDate'}
                                                                    id={T.t('DateFilter')}
                                                                    checked={this.createdDateStatus(formik, 'CompletionDate')}
                                                                    style={{ borderRadius: 100 }}
                                                                />
                                                                <div className="control__indicator" />
                                                            </span>
                                                        </div>
                                                    </div>
                                                    {this.state.guid === ReportType.StandartReport ? (
                                                        <div className="col col-md-4 col-sm-6 col-6 pb-3">
                                                            <div className="form-input form-group date-picker">
                                                                <SelectNoneAsync
                                                                    name={'rowNameList'}
                                                                    isMulti={true}
                                                                    setFieldValue={formik.setFieldValue}
                                                                    setOptions={[
                                                                        { value: 'Giriş Sayısı', label: T.t('r_login_count') },
                                                                        {
                                                                            value: 'Canlı İzleme Süresi',
                                                                            label: T.t('r_sync_virtual_class_viewers')
                                                                        },
                                                                        { value: 'Hafta(lar)', label: T.t('r_report_weeks') },
                                                                        { value: 'Son Giriş Tarihi', label: T.t('r_last_login_date') },
                                                                        {
                                                                            value: 'Tekrar İzleme Sayısı',
                                                                            label: T.t('r_report_repeat_watch_count')
                                                                        },
                                                                        {
                                                                            value: 'Toplam Katılım Süresi',
                                                                            label: T.t('r_report_total_join_time')
                                                                        },
                                                                        { value: 'Yükleme Sayısı', label: T.t('r_report_upload_count') },
                                                                        {
                                                                            value: 'İlk Giriş Tarihi',
                                                                            label: T.t('r_report_first_login_date')
                                                                        },
                                                                        { value: 'İndirme Satısı', label: T.t('r_report_download_count') }
                                                                    ]}
                                                                    // tslint:disable-next-line:jsx-no-lambda
                                                                    onChange={(e: any) =>
                                                                        formik.setFieldValue('rowNameList', this.handleSelectedRows(e))
                                                                    }
                                                                    isTouched={formik.setFieldTouched}
                                                                    placeHolder={T.t('r_add_scope')}
                                                                    className='my-custom-react-select-mid'

                                                                />
                                                            </div>
                                                        </div>
                                                    ) : (
                                                        ''
                                                    )}
                                                    {this.state.isSelected && this.state.guid !== ReportType.PivotTableReport
                                                        &&
                                                        <div className='col' >
                                                            <div className=' d-flex flex-row'>
                                                                <div style={{ width: "20%" }}>
                                                                    <Select
                                                                        options={options}
                                                                        value={this.state.selectedOption}
                                                                        onChange={this.onChangeTake}
                                                                        styles={customStyles}
                                                                    />
                                                                </div>
                                                                <p className="pt-3 pl-1"> {T.t('r_data_per_page')}</p>
                                                            </div>
                                                        </div>
                                                    }
                                                    <div className='col' >
                                                        <div className="ml-auto text-right mx-3 mb-2">
                                                            <button
                                                                type="button"
                                                                onClick={this.validateAndSubmit.bind(this, formik)}
                                                                className="ml-2 category-tag-square tag-green"
                                                            >
                                                                {T.t('r_gen_search')}{' '}
                                                                <i style={{ fontSize: 18 }} className="material-icons ml-2">
                                                                    search
                                                                </i>
                                                            </button>
                                                            {/* <a
                                                                // tslint:disable-next-line:jsx-no-lambda
                                                                onClick={this.clearFilters.bind(this, formik)} className="btn report_btn ml-auto">{T.t('r_gen_reports_set_filter')}</a> */}
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>

                                        </form>
                                    );
                                }}
                            </Formik>
                            {this.state.guid !== ReportType.StandartReport ? (
                                <div className="question-list mt-3">
                                    <div className="info-box">
                                        <p>
                                            {T.t('r_gen_reports_info_start')}
                                            <b>{T.t('r_gen_download_full_data')}</b>
                                            {T.t('r_gen_reports_info_end')}
                                        </p>
                                    </div>
                                </div>
                            ) : (
                                ''
                            )}
                        </div>
                    </div>
                    {this.viewReportTable(basicReportRows, basicReportData, totalRowCount, dataLength, pivotReportData)}
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state: IAppState, ownProps: IEnrollmentReportsProps): IEnrollmentReportsProps => {
    if (!state) {
        return ownProps;
    }
    const newProps: IEnrollmentReportsProps = Object.assign({}, ownProps, {
        userPreferences: state.profile.userPreferences.preferences,
        culture: state.login.identitiy.culture
    });
    return newProps;
};

const areStatesEqual = (next: IAppState, prev: IAppState) => {
    const ret = next.profile.userPreferences === prev.profile.userPreferences;
    return ret;
};

const dispatchProps = (dispatch: Dispatch<IAction>) => {
    return {
        dispatch
    };
};

const CEnrollmentReports = connect(mapStateToProps, dispatchProps, null, {
    areStatesEqual
})(EnrollmentReports);

export default CEnrollmentReports;
